/**
 * @file: ResourcePublish.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 信息发布管理
 */
import request from '@/utils/request'

/**
 * 添加资源信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function resourcePublishAdd(data) {
  return request({
    type: 'biz',
    url: 'resource/publish/add',
    method: 'post',
    data
  })
}

/**
 * 信息发布平台-承包商信息列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function resourcePublishContractorList(data) {
  return request({
    type: 'biz',
    url: 'resource/publish/contractor/list',
    method: 'post',
    data
  })
}

/**
 * 删除资源信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function resourcePublishDelete(data) {
  return request({
    type: 'biz',
    url: 'resource/publish/delete',
    method: 'post',
    data
  })
}

/**
 * 查询资源已启用的列表信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function resourcePublishEnbaleList(data) {
  return request({
    type: 'biz',
    url: 'resource/publish/enbale/list',
    method: 'post',
    data
  })
}

/**
 * 更新启用标识(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function resourcePublishEnbaleUpdate(data) {
  return request({
    type: 'biz',
    url: 'resource/publish/enbale/update',
    method: 'post',
    data
  })
}

/**
 * 查询资源信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function resourcePublishGet(data) {
  return request({
    type: 'biz',
    url: 'resource/publish/get',
    method: 'post',
    data
  })
}

/**
 * 查询资源列表信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function resourcePublishList(data) {
  return request({
    type: 'biz',
    url: 'resource/publish/list',
    method: 'post',
    data
  })
}

/**
 * 信息发布平台-获取流视频(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function resourcePublishStreamGet(data) {
  return request({
    type: 'biz',
    url: 'resource/publish/stream/get',
    method: 'post',
    data
  })
}

/**
 * 修改资源信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function resourcePublishUpdate(data) {
  return request({
    type: 'biz',
    url: 'resource/publish/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/ResourcePublish.js